import { TextField, MenuItem } from '@mui/material'
import { CONTROLS } from '~/components/Charts/chrome/chartChrome'

type RawOption = string | { value: string; label: string }

interface Props {
  options: RawOption[]
  value: string
  onChange: (v: string) => void
}

function normalize(o: RawOption): { value: string; label: string } {
  return typeof o === 'string' ? { value: o, label: o } : o
}

export function KpiSelector({ options, value, onChange }: Props) {
  const normalized = options.map(normalize)
  // If the URL-sourced value is not in the fetched option list, prepend it.
  const optionList = normalized.some((o) => o.value === value)
    ? normalized
    : [{ value, label: value }, ...normalized]
  return (
    <TextField
      select
      label={CONTROLS.kpi}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{ minWidth: 200 }}
    >
      {optionList.map((o) => (
        <MenuItem key={o.value} value={o.value}>
          {o.label}
        </MenuItem>
      ))}
    </TextField>
  )
}
